import { ChangeCartBirthDateResult } from '../../../graphql/cart/changeCartBirthDate';
import { CustomOrderType } from '../../carts/CustomOrderType';
import { createAction } from '@reduxjs/toolkit';

export interface ApiCartChangeCartBirthDateRequestedPayload {
  readonly actionId: number;
  readonly customOrderType: CustomOrderType;
  readonly birthDate: string;
  readonly parentActionId: number;
}
export const apiCartChangeCartBirthDateRequestedType = 'api/cart/changeCartBirthDate--requested';
export const apiCartChangeCartBirthDateRequested =
  createAction<ApiCartChangeCartBirthDateRequestedPayload>(apiCartChangeCartBirthDateRequestedType);
export type ApiCartChangeCartBirthDateRequestedAction = ReturnType<
  typeof apiCartChangeCartBirthDateRequested
>;

export interface ApiCartChangeCartBirthDateSucceededPayload {
  readonly cartId: string;
  readonly result: ChangeCartBirthDateResult;
  readonly requestedActionId: number;
  readonly parentActionId: number;
}
export const apiCartChangeCartBirthDateSucceededType = 'api/cart/changeCartBirthDate--succeeded';
export const apiCartChangeCartBirthDateSucceeded =
  createAction<ApiCartChangeCartBirthDateSucceededPayload>(apiCartChangeCartBirthDateSucceededType);
export type ApiCartChangeCartBirthDateSucceededAction = ReturnType<
  typeof apiCartChangeCartBirthDateSucceeded
>;

export interface ApiCartChangeCartBirthDateFailedPayload {
  readonly requestedActionId: number;
  readonly parentActionId: number;
}
export const apiCartChangeCartBirthDateFailedType = 'api/cart/changeCartBirthDate--failed';
export const apiCartChangeCartBirthDateFailed =
  createAction<ApiCartChangeCartBirthDateFailedPayload>(apiCartChangeCartBirthDateFailedType);
export type ApiCartChangeCartBirthDateFailedAction = ReturnType<
  typeof apiCartChangeCartBirthDateFailed
>;
